import { defineMessages } from 'react-intl';

export default defineMessages({
    // add string ids and default values for localization here
    clQuoteValidityDays: {
        id: 'quoteandbind.views.pcl.quote.Quote Validity Days',
        defaultMessage: 'THIS QUOTE IS VALID FOR {quoteValidityDays} DAYS - COVERAGE IS NOT BOUND UNTIL A BINDER IS ISSUED',
    },
});
